import React, { FunctionComponent, useContext } from 'react';
import { Helmet } from 'react-helmet';
import get from 'lodash/get';
import { BrandStore } from '../../context';

/**
 * We can use this component in the future for any chat customizations we may
 * need. For now it's just the default chat experience so we only need the
 * script embed. @see tracking.util.ts for where we send in the merchant and
 * user information to HubSpot.
 */

export const LiveChat: FunctionComponent = () => {
  const {
    state: { brand },
  } = useContext(BrandStore);

  return get(brand, 'showLiveChat', null) ? (
    <div data-testid="live-chat-wrapper">
      <Helmet>
        <script
          src={`//js.hs-scripts.com/${process.env.REACT_APP_HUBSPOT_ACCOUNT_ID}.js`}
        ></script>
      </Helmet>
    </div>
  ) : null;
};
